import React from 'react';
import { GenericDialog } from '@AMIEWEB/Alerts/GenericDialog';
import { useTranslation } from 'react-i18next';
import { IDuplicateCandidateContact } from 'app/models/Candidate/CandidateProfile';
import { DuplicateContactTable } from './DuplicateContactTable';

interface IDuplicateContactDialogProps {
  open: boolean;
  duplicates: IDuplicateCandidateContact[];
  onClose: () => void;
}

export const DuplicateContactDialog = ({ open, duplicates, onClose }: IDuplicateContactDialogProps) => {
  const { t } = useTranslation();

  return (
    <GenericDialog
      open={open}
      disableEscapeKeyDown
      maxWidth="lg"
      fullWidth
      dialogTitleProps={{
        text: t('candidate.contactTab.duplicate.title', 'Duplicates exist'),
        closeButton: true,
        onClose,
      }}
      dialogActions={[
        {
          text: t('candidate.contactTab.duplicate.close', 'Close'),
          variant: 'contained',
          color: 'primary',
          onClick: onClose,
        },
      ]}
      variant={'blue'}
      onClose={onClose}
    >
      <div data-testid="duplicate-contact-dialog">
        <DuplicateContactTable duplicates={duplicates} />
      </div>
    </GenericDialog>
  );
};
